<template>
  <div class="sy-nav">
    <van-nav-bar v-if="navbartitle" class="title" :title="$t('routerBase.'+$route.meta.title)" left-arrow fixed @click-left="onClickLeft" />
    <div class="content">
      <div class="size12">
        {{ $t('privacypolicy.a') }}
      </div>
      <div class="size16 top16">
        {{ $t('privacypolicy.b') }}<br>
        <span class="size12">● 1. {{ $t('privacypolicy.c') }} </span><br>
        <span class="size12">● 2. {{ $t('privacypolicy.d') }} </span><br>
        <span class="size12">{{ $t('privacypolicy.f') }} </span><br>
        <span class="size12">{{ $t('privacypolicy.g') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.h') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.i') }}</span>
      </div>
      <div class="size16 top16">
        {{ $t('privacypolicy.j') }}<br>
        <span class="size12">{{ $t('privacypolicy.k') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.l') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.m') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.n') }}</span><br>
      </div>
      <div class="size16 top16">
        {{ $t('privacypolicy.o') }}<br>
        <span class="size12">{{ $t('privacypolicy.p') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.q') }}</span><br>
      </div>
      <div class="size16 top16">
        {{ $t('privacypolicy.r') }}<br>
        <span class="size12">{{ $t('privacypolicy.s') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.t') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.u') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.v') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.w') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.x') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.y') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.z') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.aa') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.bb') }}</span><br>
      </div>
      <div class="size16 top16">
        {{ $t('privacypolicy.cc') }}<br>
        <span class="size12">{{ $t('privacypolicy.dd') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.ee') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.ff') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.gg') }}</span><br>
      </div>
      <div class="size16 top16">
        {{ $t('privacypolicy.hh') }}<br>
        <span class="size12">{{ $t('privacypolicy.ii') }} </span><br>
        <span class="size12">{{ $t('privacypolicy.jj') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.kk') }} </span><br>
        <span class="size12">{{ $t('privacypolicy.ll') }}  </span><br>
        <span class="size12">{{ $t('privacypolicy.mm') }} </span><br>
        <span class="size12">{{ $t('privacypolicy.nn') }}</span><br>
        <span class="size12">{{ $t('privacypolicy.oo') }}</span><br>
      </div>
      <div class="size16 top16">
        {{ $t('privacypolicy.pp') }}<br>
        <span class="size12">
          {{ $t('privacypolicy.qq') }}
        </span>
      </div>
      <div class="size16 top16">
        {{ $t('privacypolicy.rr') }}<br>
        <span class="size12">
          {{ $t('privacypolicy.ss') }}
        </span>
      </div>
      <div class="size13">
        {{ $t('privacypolicy.tt') }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      navbartitle: true
    }
  },
  created() {
    if (window.location.href.indexOf('navbartitle') !== -1) {
      this.navbartitle = false
    } else {
      this.navbartitle = true
    }
  },
  methods: {
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
      //   Toast('返回')
    }
  }
}
</script>

<style scoped lang="scss">
  .sy-nav {
    height: 100vh;
    background: white;
  }
  .title{
    box-shadow:0px 3px 4px 0px rgba(190,190,190,0.3);
  }
  .content {
    background-color: white;
    padding: 18px 12px;
    .size12{
      font-size:12px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      line-height:21px;
    }
    .top16{
      padding-top: 16px;
      padding-bottom: 5px;
    }
    .size13{
      font-weight: bold;
      font-size:13px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      line-height:21px;
    }
    .size16{
      font-weight: bold;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      line-height:21px;
    }
  }
  /deep/.van-nav-bar .van-icon {
    color: #F18937;
    vertical-align: middle;
  }
</style>

